import { ServiceArea } from "@app/service-areas/serviceArea";
import { ServiceAreaVersionModel } from "@app/service-areas/serviceAreaVersionModel";
import ServiceBase from "@app/shared/serviceBase";

/** Handles retrieval operations for service areas. */
export default class ServiceAreaService extends ServiceBase {
  private serviceAreaEndpoint = `${this.apiEndpoint}/servicearea`;

  /**
   * Retrieves all Service Areas for the current user. Optionally includes shared Service Areas and version information for each Service Area.
   */
  public async getServiceAreas(includeVersions: boolean): Promise<ServiceArea[]> {
    return await this.makeGet<ServiceArea[]>("", { includeVersions }, this.serviceAreaEndpoint);
  }

  /**
   * Gets the latest version of a service area. By default, it gets the latest "activated" version, returning null if there is no activated version.
   */
  public async getLatestServiceAreaVersion(serviceAreaId: number): Promise<ServiceAreaVersionModel> {
    return await this.makeGet<ServiceAreaVersionModel>(`${serviceAreaId}/versions/latest`, null, this.serviceAreaEndpoint);
  }
}
